/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import { trailLogout } from '../../../utils/activityTrail';
import { Link, useHistory } from 'react-router-dom';
import util from "../../../utils/util";
import { Dropdown, Avatar, Tooltip, Switch } from 'antd';
import { sdx } from '../../../sdx';
import user from './circle-user-solid.svg'
import {
    DownOutlined, UserOutlined, LogoutOutlined,
    BarChartOutlined, AimOutlined
} from '@ant-design/icons';
let $ = window.$;

export default function Header() {
    const history = useHistory();
    const [scoringMode, setScoringMode] = useState(
        () => localStorage.getItem('qoc_scoring_mode') || 'benchmark'
    );

    const toggleSidebarCollapse = (e) => {
        e.preventDefault();
        if ($("body").hasClass("page-sidebar-closed")) {
            $("body").removeClass("page-sidebar-closed");
        } else {
            $("body").addClass("page-sidebar-closed");
        }
    }

    const toggleResponsiveSidebarCollapse = (e) => {
        e.preventDefault();
        if ($("body").hasClass("page-sidebar-mobile-offcanvas-open")) {
            $("body").removeClass("page-sidebar-mobile-offcanvas-open");
            $(".page-sidebar-cover").hide();
        } else {
            $("body").addClass("page-sidebar-mobile-offcanvas-open");
            $(".page-sidebar-cover").show();
        }
    }

    useEffect(() => {
        // Persist scoring mode in sdx global state on mount
        sdx.setData({ scoringMode });
        // eslint-disable-next-line
    }, []);

    const handleScoringToggle = (checked) => {
        const mode = checked ? 'benchmark' : 'original';
        setScoringMode(mode);
        localStorage.setItem('qoc_scoring_mode', mode);
        sdx.setData({ scoringMode: mode });
        // Reload current page data by dispatching a custom event
        window.dispatchEvent(new CustomEvent('scoringModeChanged', { detail: { mode } }));
    };

    const userDDItems = [
        { label: <Link to="/profile"><UserOutlined /> My Profile</Link>, key: '1' },
        { label: <div className="cpointer" onClick={(e) => { trailLogout(util.getLoggedName()); util.logout(e, history); }}><LogoutOutlined /> Logout</div>, key: '3', visible: 'Y' },
    ];

    return (
        <div className="page-header navbar navbar-fixed-top d-print-none">
            <div className="d-flex h-100">
                <div className="page-logo my-auto">
                    <img src="assets/img/elogo.png" alt="logo" width="80" className="logo-default" style={{ marginTop: '-8px' }} />
                    <div className="menu-toggler sidebar-toggler" onClick={toggleSidebarCollapse}> <span></span> </div>
                </div>
                <div className="my-auto uc" style={{ color: '#ffffff' }}>
                    Digital Quality Assessment System
                </div>

                {/* ── Scoring Mode Toggle ───────────────────────────── */}
                <div className="my-auto ml-auto" style={{ display: 'flex', alignItems: 'center', gap: 8, marginRight: 16 }}>
                    <Tooltip title={
                        scoringMode === 'benchmark'
                            ? 'Benchmark-Adjusted: Scores calculated against facility-type expected MEs. More accurate for comparison.'
                            : 'Original: Scores calculated on answered MEs only. May be inflated for incomplete forms.'
                    }>
                        <div style={{
                            display: 'flex', alignItems: 'center', gap: 6,
                            background: 'rgba(255,255,255,0.12)',
                            padding: '4px 10px', borderRadius: 20,
                            cursor: 'pointer'
                        }}>
                            <AimOutlined style={{ color: scoringMode === 'original' ? '#fadb14' : '#aaa', fontSize: 13 }} />
                            <span style={{ color: '#ccc', fontSize: 11 }}>Original</span>
                            <Switch
                                size="small"
                                checked={scoringMode === 'benchmark'}
                                onChange={handleScoringToggle}
                                style={{ background: scoringMode === 'benchmark' ? '#52c41a' : '#666' }}
                            />
                            <span style={{ color: scoringMode === 'benchmark' ? '#52c41a' : '#aaa', fontSize: 11, fontWeight: 700 }}>
                                Benchmark
                            </span>
                            <BarChartOutlined style={{ color: scoringMode === 'benchmark' ? '#52c41a' : '#aaa', fontSize: 13 }} />
                        </div>
                    </Tooltip>
                </div>

                <div className='my-auto bg-white badge-pill'>
                    <div className="h-100 p-2">
                        <Dropdown
                            placement="bottomRight"
                            trigger={["click"]}
                            menu={{ items: userDDItems }}
                        >
                            <div className="cpointer d-flex align-items-center">
                                <div className="">
                                    <img src={user} alt='user' height={20}/>
                                </div>
                                <div className="ml-auto d-flex align-items-center pl10">
                                    <div className="ellipsis pr10 font-weight-bold" style={{ maxWidth: 100, color: '#2d5f8b' }}>
                                        {util.getLoggedName()}
                                    </div>
                                    <div>
                                        <DownOutlined className="fs13 font-weight-bold" style={{ color: '#2d5f8b' }} />
                                    </div>
                                </div>
                            </div>
                        </Dropdown>
                    </div>
                </div>

                <div className="my-auto pl20">
                    <a href="/" className="my-auto menu-toggler responsive-toggler" data-toggle1="collapse" data-target1=".navbar-collapse" onClick={toggleResponsiveSidebarCollapse}>
                        <span></span>
                    </a>
                </div>
            </div>
        </div>
    );
}